export default {
  activateLandingPageTitle: 'Events',
  activateProductCardTitle: 'Events',
  activateProductPageTitle: 'Book Events',
  allProductsLandingPageTitle: 'Book Unique Experiences',
  apply: 'Apply',
  buyTickets: 'Buy tickets',
  cancel: 'Cancel',
  clear: 'Clear',
  clearFilters: 'Clear filters',
  discoverExperiences: 'Discover experiences',
  exclusive: 'Exclusive',
  experience: 'experience',
  experiencePhotoOfListing:
    'Experience photo {{photoNumber}} of listing {{listingTitle}}',
  experiences: 'experiences',
  filterExperiences: 'Filter experiences',
  fromListingCard: 'From',
  hostedBy: 'Hosted by',
  hostLandingPageTitle: 'Local experiences',
  hostProductCardTitle: 'Local Experiences',
  hostProductPageTitle: 'Book Local Experiences',
  landingPageTitle: 'Book Unique Experiences',
  mainLandingPageTitle: 'All Experiences',
  more: 'More',
  noExperiencesFound: 'No experiences found',
  noExperiencesFoundFor: 'No experiences found for',
  experiencesFoundCount: '{{count}} experiences found',
  profileImageOfHost: 'Profile image of host {{hostName}}',
  reserve: 'Reserve',
  reserveLandingPageTitle: 'Activities & amenities',
  reserveProductCardTitle: 'Activities',
  reserveProductPageTitle: 'Book Activities & Amenities',
  resultsPageTitle: 'Book Experiences & Activities',
};
